/**
 * Google Search Console verification.
 *
 * Sprint 1 consolidation: the canonical verification meta tag is hardcoded
 * directly in `index.html` (token: noieXA7OMlbkeQ5j7NfAlV2dAlWgMqFm6ZxB870w0FE).
 * That is the only verification path in use. This component remains as a
 * safe no-op so existing imports keep compiling; it will only inject a
 * tag if a project ever sets VITE_GSC_VERIFICATION_TOKEN AND the static
 * tag is somehow missing — preventing duplicate verification tags.
 */
import { useEffect } from "react";

const TOKEN = (import.meta.env.VITE_GSC_VERIFICATION_TOKEN as string | undefined) || "";

export function isSearchConsoleConfigured(): boolean {
  // Static token in index.html is always present; treat GSC as configured.
  return true;
}

export default function SearchConsoleVerification() {
  useEffect(() => {
    if (!TOKEN.trim()) return;
    if (typeof document === "undefined") return;
    // Do not duplicate: only inject when no static verification tag exists.
    const existing = document.querySelector('meta[name="google-site-verification"]');
    if (existing) return;
    const meta = document.createElement("meta");
    meta.setAttribute("name", "google-site-verification");
    meta.setAttribute("content", TOKEN);
    document.head.appendChild(meta);
  }, []);
  return null;
}
